import * as $runtime from "../runtime.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Restaumatic$dCurrencies from "../Restaumatic.Currencies/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dCurrency from "../Restaumatic.I18n.Currency/index.js";
import {getGlobalCurrencyRaw} from "./foreign.js";
const getGlobalCurrency = () => {
  const x = getGlobalCurrencyRaw();
  return Restaumatic$dCurrencies.unscrambleDecodeCurrency.unsafeDecode(x);
};
const currency = value => Restaumatic$dI18n$dCurrency.formatCurrency(getGlobalCurrency())(value);
const formatNumberAsCurrency = x => Restaumatic$dI18n$dCurrency.formatCurrency(getGlobalCurrency())(Data$dMoney$dRounded.roundCents(x * 100.0));
const _localizePath = locale => defaultLocale => path => {
  if (
    (() => {
      if (locale.tag === "PL") { return defaultLocale.tag === "PL"; }
      if (locale.tag === "EN") { return defaultLocale.tag === "EN"; }
      if (locale.tag === "EN_GB") { return defaultLocale.tag === "EN_GB"; }
      if (locale.tag === "RO") { return defaultLocale.tag === "RO"; }
      if (locale.tag === "RU") { return defaultLocale.tag === "RU"; }
      if (locale.tag === "CS") { return defaultLocale.tag === "CS"; }
      if (locale.tag === "SK") { return defaultLocale.tag === "SK"; }
      if (locale.tag === "HR") { return defaultLocale.tag === "HR"; }
      if (locale.tag === "DE") { return defaultLocale.tag === "DE"; }
      if (locale.tag === "NL") { return defaultLocale.tag === "NL"; }
      if (locale.tag === "ES") { return defaultLocale.tag === "ES"; }
      if (locale.tag === "IT") { return defaultLocale.tag === "IT"; }
      if (locale.tag === "UK") { return defaultLocale.tag === "UK"; }
      if (locale.tag === "PT_BR") { return defaultLocale.tag === "PT_BR"; }
      return false;
    })()
  ) {
    return "/" + path;
  }
  return "/" + (() => {
    if (locale.tag === "PL") { return "pl"; }
    if (locale.tag === "EN") { return "en"; }
    if (locale.tag === "EN_GB") { return "en-GB"; }
    if (locale.tag === "RO") { return "ro"; }
    if (locale.tag === "RU") { return "ru"; }
    if (locale.tag === "CS") { return "cs"; }
    if (locale.tag === "SK") { return "sk"; }
    if (locale.tag === "HR") { return "hr"; }
    if (locale.tag === "DE") { return "de"; }
    if (locale.tag === "NL") { return "nl"; }
    if (locale.tag === "ES") { return "es"; }
    if (locale.tag === "IT") { return "it"; }
    if (locale.tag === "UK") { return "uk"; }
    if (locale.tag === "PT_BR") { return "pt-BR"; }
    $runtime.fail();
  })() + "/" + path + "/";
};
const localizeRoute = path => {
  const $0 = Restaumatic$dI18n.getGlobalLocale(Effect$dClass.monadEffectEffect);
  return () => {
    const locale = $0();
    const defaultLocale = Restaumatic$dI18n.getGlobalDefaultLocale();
    return _localizePath(locale)(defaultLocale)(path);
  };
};
export {_localizePath, currency, formatNumberAsCurrency, getGlobalCurrency, localizeRoute};
export * from "./foreign.js";
